var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3002 0.862918C19.5312 1.09386 19.661 1.40506 19.6634 1.72609C19.6658 2.0468 19.5409 2.35129 19.3182 2.57406L14.7641 7.12813L14.8276 7.39882L17.2183 17.6671L16.2957 18.5896L12.1352 10.674L11.8197 10.0726L6.84161 15.0506L6.92516 15.3358L7.94508 18.8196L7.39472 19.3699L4.87497 15.4401L4.81558 15.3476L4.72374 15.2889L0.793911 12.7691L1.34427 12.2187L4.8287 13.238L5.11389 13.3215L10.092 8.34347L9.4898 8.02721L1.57421 3.86812L2.49677 2.94557L12.765 5.3362L13.0357 5.39973L17.5898 0.845655C17.8125 0.622881 18.117 0.497995 18.4377 0.500388C18.7586 0.502818 19.0693 0.632191 19.3002 0.862918Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlts);
export default __webpack_public_path__ + "static/media/flts.9d556cc8390fbf846179f8066eb7d932.svg";
export { ForwardRef as ReactComponent };